import { useEffect, useState } from 'react';
import useHeaderContext from '_common/hooks/useHeaderContext';
import getAnalyticsConfiguration from './webAnalyticsService';
import authService from '../authentication/AuthorizeService';

const MyGuideTracker = () => {
  const [coreReady, setCoreReady] = useState(false);
  const { headerContext } = useHeaderContext();
  useEffect(() => {
    async function renderMyGuide() {
      if (!coreReady && headerContext.coreFrameLoaded) {
        setCoreReady(true);
        const userProfile = await authService.getUserProfile();
        if (userProfile === null || userProfile.personguid === '') {
          return null;
        }
        const visitorId = userProfile.personguid;
        const emailExt = '@sumtotal.com';
        const myGuideEmail = visitorId + emailExt;
        const analyticsData = await getAnalyticsConfiguration(false);
        const myGuideEnabled = analyticsData.webAnalyticIsEnable === '1';
        const analyticUrl = analyticsData.webAnalyticSiteUrl;
        const apiKey = analyticsData.webAnalyticSiteID;

        // only load the MyGuide source and Initialization when MyGuide has been enabled for the tenant
        if (myGuideEnabled === true) {
          // script used to load the MyGuide resource
          // this script is not in a seperate file, as it's using some variables that must first be obtained via webanalytic service call
          const myGuideSourceScript = `if(!window.guideMe)window.guideMe={}; window.__MG__={}; window.__MG__.email='${myGuideEmail}'; window.__MG__.fullName='${visitorId}'; window.myGuideOrgKey='${apiKey}'; window.guideMe.baseUrl='${analyticUrl}'; var a=document.createElement('script');
            a.src='${analyticUrl}'+'guideme.js'; document.head.appendChild(a);`;
          const myGuideLoadScript = document.createElement('script');
          myGuideLoadScript.type = 'text/javascript';
          myGuideLoadScript.async = true;
          myGuideLoadScript.innerHTML = myGuideSourceScript;
          document.head.appendChild(myGuideLoadScript);
        }
      }
    }
    renderMyGuide();
  }, [headerContext.coreFrameLoaded, coreReady]);
  return null;
};
export default MyGuideTracker;
